
import {ADD_CREATE_TABLE_ROW} from '../_CONSTANTS';

export const add_Create_Table_Row = (instrumentType, testName, accountId) => {

  return {
    type: ADD_CREATE_TABLE_ROW,
    payload: {instrumentType: instrumentType, testName: testName, accountId}
  }
}